// @ts-ignore
import {ApiValidation} from '../../model/api/api-validation';
import {CrystalclearBackUrl} from './crystalclear-back-url';
import {ApiFileResponse} from "../../model/api/api-file-response";

export class CrystalclearWebAssetsBackUrl {
  //WEB ASSETS
  static readonly WEB_ASSET_LOAD_CONFIG: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/assets/load-config',
    type: ApiValidation
  };
  static readonly GET_MODULES_VERSION: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/assets/modules-version',
    type: ApiValidation
  };
  // Authenticated-only counterpart to WEB_ASSET_LOAD_CONFIG: everything that isn't needed to
  // render the login page itself (feature flags, reload intervals, allocation/trade limits...).
  static readonly WEB_ASSET_APP_CONFIG: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/assets/app-config',
    type: ApiValidation
  };
}
